import React from 'react'
import PropTypes from 'prop-types'
import ApolloError from '../ApolloErrorPage/ApolloError'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError (error) {
    if (error) return { hasError: true }
  }

  render () {
    if (this.state.hasError) {
      return (
        <ApolloError
          venture={this.props.venture}
          ConfigContext={this.props.ConfigContext}
        />
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  venture: PropTypes.string,
  ConfigContext: PropTypes.object,
  children: PropTypes.object
}

export default ErrorBoundary
